import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import Rails from 'rails-ujs';

type Props ={
  alertType: string,
  subject: string,
  body: string,
};

const PopupAlertModal: React.FC<Props> = ({
  alertType,
  subject,
  body,
}) => {
  const [isModalShown, setIsModalShown] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleClose = async (e) => {
    e.preventDefault();
    await dismissAlert();
    setIsModalShown(false);
  }

  const dismissAlert = async () => {
    try {
      await axios.request({
        url: `/user/popup_alerts/${alertType}`,
        method: 'delete',
        headers: {
          'X-CSRF-Token': Rails.csrfToken(),
        },
      });
      setIsModalShown(false);
    } catch (error) {
      console.error("Error marking notification as read:", error);
      setErrorMessage("処理に失敗しました。画面を再読み込みしてください。");
    }
  }

  return (
    <>
      <Modal show={isModalShown} onHide={dismissAlert}>
        <Modal.Header closeButton>
          <Modal.Title>{subject}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          dangerouslySetInnerHTML={{__html: body}}
        />
        <Modal.Footer className="justify-content-between">
          <div className="text-danger text-small">
            {errorMessage}
          </div>
          <Button variant="secondary" onClick={handleClose}>
            閉じる
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PopupAlertModal;